import React from 'react'
import cn from 'classnames'
import Vimeo, { VimeoProps } from '@u-wave/react-vimeo'
import { memo } from '~/ui/component'
import { VBox } from '~/ui/components'
import { createUseStyles, layout } from '~/ui/styling'

export interface Props extends VimeoProps {
  classNames?: React.ClassNamesProp
}

const VimeoPlayer = memo('VimeoPlayer', (props: Props) => {

  const {
    classNames,
    ...rest
  } = props

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <VBox classNames={[$.VimeoPlayer, classNames]}>
        <Vimeo
          {...rest}
          className={cn($.youtube, rest.className)}
        />
      </VBox>
    )
  }

  return render()

})

export default VimeoPlayer

const useStyles = createUseStyles({
  VimeoPlayer: {
    position: 'relative',
    paddingTop: 9/16 * 100 + '%',
  },

  youtube: {
    ...layout.overlay,

    '& > iframe': {
      width: '100%',
      height: '100%',
    },
  },
})